export default "__VITE_ASSET__CwF9LCP7__"